import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { Box, Grid, Typography } from '@mui/material'
import { ThemeProvider, createTheme, ThemeOptions } from '@mui/material/styles'
import { translate } from '../i18n'
import { EMBED_ANALYTICS_COLORS } from '../components'
import baseTheme from '../theme.json'
import ProjectAnalytics from './ProjectAnalytics'

// Reuse the app's typography/base while swapping the primary accent to the
// embed purple, so every MUI control inside the embed (filter inputs, selects,
// dropdown menus, calendar popup) picks up the branded color automatically.
const embedTheme = createTheme({
    ...(baseTheme as ThemeOptions),
    palette: {
        ...(baseTheme as ThemeOptions).palette,
        primary: {
            main: EMBED_ANALYTICS_COLORS.data,
            // The cyan is light enough that MUI would auto-pick black text;
            // force the same white used on the summary tiles.
            contrastText: EMBED_ANALYTICS_COLORS.onData,
        },
    },
})

/**
 * Public, session-less page meant to be loaded inside third-party iframes:
 * /embed/analytics?projectId=<id>
 */
export default function EmbeddedAnalytics() {
    const location = useLocation()

    const projectId = useMemo(
        () => new URLSearchParams(location.search).get('projectId') ?? '',
        [location.search]
    )

    return (
        <ThemeProvider theme={embedTheme}>
            <Box sx={{ p: 2 }}>
                {projectId ? (
                    <Grid container>
                        <ProjectAnalytics projectId={projectId} embedded />
                    </Grid>
                ) : (
                    <Typography
                        variant="body2"
                        align="center"
                        color="text.secondary"
                    >
                        {translate('projects.analytics.share.missing_project')}
                    </Typography>
                )}
            </Box>
        </ThemeProvider>
    )
}
